

<template>
  <div class="mod" :class="isEn ? 'isEn' : ''">
    <div class="top-banner">
      <span class="about-label banner-txt-con" :style="{ left: `${left}px` }">
        {{$t('about-icon-txt2')}}
        <span>{{$t('dev-banner-txt2')}} </span>
      </span>
      <!-- <img src="@/assets/img/production.png" @load="bannerloadEvent" /> -->
    </div>
    <div class="linkBox">
      <div class="link-tab">
        <div @click="tabEvent(0, 'jishupingtai',-90)" :class="btnActiveIndex === 0 ? 'link-btn link-btn-active' : 'link-btn'">
          {{ $t('dev-btn-txt1') }}</div>

        <div @click="tabEvent(1, 'yanfaguanxian',-290)"
          :class="btnActiveIndex === 1 ? 'link-btn link-btn-active' : 'link-btn'">
          {{ $t('dev-btn-txt2') }}</div>

        <!-- <div @click="tabEvent(2, 'shengchanzhiliang',-40)"
          :class="btnActiveIndex === 2 ? 'link-btn link-btn-active' : 'link-btn'">{{ $t('dev-btn-txt3') }}
        </div> -->
      </div>
    </div>
    <div class="body">
      <div class="group-4" id="jishupingtai">
        <div class="group-5">
          <div class="caption-wrapper">
            <span class="caption">{{$t('dev-btn-txt1')}}</span>
          </div>
          <div class="group-6">
            <!-- <div class="group-7">
              
            </div> -->
            <div class="group-8-2 group-8 flex" :class="{ 'flex3': selectStatus === 'one' }"
              @mouseover="onmouseoverEvent('one')">

              <div class="big" v-if="selectStatus === 'one'">
                <div class="block">
                  <span class="title">{{$t('dev-part1-c1-txt1')}}<span class="small"> (AAV)</span></span>
                  <span class="label-1">{{$t('dev-part1-c1-txt11')}}</span>
                </div>
                <div class="horizontal-line" />
                <span class="caption-1" v-show="!isEn">{{$t('dev-part1-c1-txt2')}}</span>
                <span class="caption-1 isEn"  v-show="isEn">
                  Cost-effective high-yield <br/>
                  system leveraging unique intellectual <br/>property rights
                </span>
          


                <span
                  class="article">{{$t('dev-part1-c1-desc')}}</span>
              </div>
              <div class="small" v-else>
                <span class="caption-2" v-show="!isEn">{{$t('dev-part1-c1-txt1')}}<span class="small"> (AAV)</span></span>
                <span class="caption-2" v-show="isEn">Adeno-<br/>Associated<br/>Virus<br/><span class="small"> (AAV)</span></span>

                <span class="tag-1">{{$t('dev-part1-c1-txt11')}}</span>
                <div class="horizontal-line-1" />
              </div>
            </div>
            <div class="group-8-1 group-8 flex" :class="{ 'flex3': selectStatus === 'two' }"
              @mouseover="onmouseoverEvent('two')">
              <div class="big" v-if="selectStatus === 'two'">
                <div class="block">
                  <span class="title">{{$t('dev-part1-c2-txt1')}}<span class="small"> (LV)</span></span>
                  <span class="label-1">{{$t('dev-part1-c1-txt11')}}</span>
                </div>
                <div class="horizontal-line" />
                <span class="caption-1" v-show="!isEn">{{$t('dev-part1-c2-txt2')}}</span>
                <span class="caption-1 isEn" v-show="isEn">
                  Large-scale capabilities  <br/> to meet high-grade  <br/>requirements
                </span>

                <span
                  class="article">{{$t('dev-part1-c2-desc')}}</span>
              </div>
              <div class="small" v-else>
                <span class="caption-2">{{$t('dev-part1-c2-txt1')}}<span class="small"> (LV)</span></span>
                <span class="tag-1">{{$t('dev-part1-c1-txt11')}}</span>
                <div class="horizontal-line-1" />
              </div>
            </div>
            <div class="group-8-3 group-8 flex" :class="{ 'flex3': selectStatus === 'three' }"
              @mouseover="onmouseoverEvent('three')">
              <div class="big" v-if="selectStatus === 'three'">
                <div class="block">
                  <span class="title">{{$t('dev-part1-c3-txt1')}}</span>
                  <span class="label-1">{{$t('dev-part1-c3-txt11')}} </span>
                </div>
                <div class="horizontal-line" />
                <span class="caption-1 three" v-show="!isEn">{{$t('dev-part1-c3-txt2')}}</span>
                <span class="caption-1 isEn" v-show="isEn">Optimized transduction <br/>process maintains stemness while reducing <br/> the required quantity</span>

                <span
                  class="article">{{$t('dev-part1-c3-desc')}}</span>
              </div>
              <div class="small" v-else>
                <span class="caption-2" v-show="!isEn">{{$t('dev-part1-c3-txt1')}}</span>
                <span class="caption-2" v-show="isEn">Hematopoietic<br/> Stem Cell Platform</span>

                
                <span class="tag-1">{{$t('dev-part1-c3-txt11')}}</span>
                <div class="horizontal-line-1" />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="group-10">
        <div class="group-11" id="yanfaguanxian">
          <div class="group-12">
            <div class="group-13">
              <div class="caption-wrapper-1">
                <span class="caption44">{{$t('dev-part2-txt1-title-1')}}</span>
              </div>
              <span class="title-1">{{$t('dev-part2-txt1')}}</span>
              <div class="horizontal-line-3" />
              <div class="grid">
                <div class="col-item-1 active" @click="switchEvent(0)">
                  <span class="title-2 span">{{$t('dev-part2-c1-txt1')}}</span>
                </div>
                <div class="col-item-1" @click="switchEvent(1)">
                  <span class="nick-name span">{{$t('dev-part2-c2-txt1')}}</span>
                </div>
                <div class="col-item-2" @click="switchEvent(2)">
                  <span class="title-2 span">{{$t('dev-part2-c3-txt1')}}</span>
                </div>
                <div class="col-item-2" @click="switchEvent(3)">
                  <span class="title-2 span">{{$t('dev-part2-c4-txt1')}}</span>
                </div>
              </div>
            </div>
            <div class="group-14">
              <div v-for="(item, index) in listData" :key="index" v-show="index === showIndex">
                <img class="layer" :src="item.img" />
                <div class="block-2" :class="item.class">
                  <div class="container-1" :class="'item' + index">
                    <div class="wrapper" :class="{'en':isEn}">
                      <div class="group-15">
                        <!-- 第三个 -->
                        <template v-if="(index==2)">
                            <span class="num" v-if="(index==2)&&(isEn)">≈280</span>
                            <span v-if="(index==2)&&(isEn)" class="word-1 " :class="{'ml-6px':isEn}">k</span>

                            <span class="num" v-if="(index==2)&&(!isEn)">≈28</span>
                            <span v-if="(index==2)&&(!isEn)" class="word-1">万</span>
                        </template>
                        <template v-if="index!=2">
                          <span class="num" >{{ $t(item.num1) }}</span> 
                          <span class="word-1" :class="{'ml-6px':isEn}">{{ $t(item.unit1) }}</span>
                        </template>
                         
                        

                       
                        <!-- <span class="num" v-if="index!=2&&isEn">{{ item.num1 }}</span> <span v-if="index!=2&&isEn" class="word-1">{{ $t(item.unit1) }}</span> -->
                      </div>
                      <div class="group-16">
                        <span class="location"  v-if="(index!=3)">{{ $t(item.title1_1) }}</span>
                        <span class="meta">{{ $t(item.title1_2) }}</span>

                       
                      </div>
                    </div>
                    <div class="wrapper-1">
                      <div class="group-17"> 
                        <!-- <span class="num-1"  v-if="index==2&&isEn">65-130</span>
                        <span class="label-3"  v-if="index==2&&isEn">k</span> -->

                     

                        <!-- 第三个 -->
                        <template v-if="(index==2)">
                            <span class="num-1" v-if="(index==2)&&(isEn)">65-130</span>
                            <span lass="label-3" v-if="(index==2)&&(isEn)" class="word-1" :class="{'ml-6px':isEn}">k</span>

                            <span class="num-1" v-if="(index==2)&&(!isEn)">6.5-13</span>
                            <span lass="label-3" v-if="(index==2)&&(!isEn)" class="word-1">万</span>
                        </template>
                        <template v-if="index!=2">

                          <span class="num-1">{{ $t(item.num2) }}</span>
                          <span class="label-3"  :class="{'ml-6px':isEn}">{{ $t(item.unit2) }}</span>
                        </template>



                      </div>
                      <div class="group-18">
                        <span class="tag-2" v-if="(index!=3)">{{ $t(item.title2_1) }}</span>
                        <span class="subtitle">{{ $t(item.title2_2) }}</span>
                      </div>
                    </div>
                  </div>
                  <div class="container-2" :class="{'en':isEn}">
                    <span class="article-1"><span class="caption-5">{{ $t(item.name) }}</span>{{ $t(item.content) }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="group-19">
            <div class="group-20">
              <span class="caption-6">{{$t('dev-part2-txt1-title-2')}}</span>
              <div class="horizontal-line-4" />
              <span class="article-2">{{$t('dev-part2-pipe-txt2')}}</span>
            </div>
            <div class="group-21 zoomCenterTop">
              <div class="block-3">
                <div class="word-wrapper-item-0">
                  <span class="word-2">{{$t('shiyingzheng')}}</span>
                </div>
                <div class="word-wrapper-item-1">
                  <span class="word-3">{{$t('zaoqiyanjjiu')}}</span>
                </div>
                <div class="word-wrapper-item-1">
                  <span class="word-3">{{$t('linchuangqianyanjiu')}}</span>
                </div>
                <div class="word-wrapper-item-3">
                  <span class="tag-3">{{$t('linchuangpopc')}}</span>
                </div>
                <div class="word-wrapper-item-4">
                  <span class="meta-1">{{$t('xinyaolinchuangshenqing')}}</span>
                </div>
                <div class="word-wrapper-item-5">
                  <span class="tag-4">{{$t('linchangyanjiu')}}</span>
                </div>
              </div>
              <div class="block-45">
                <span class="tag-5" v-show="!isEn">{{$t('about-icon-txt2')}}</span>
                <span class="tag-5" v-show="isEn"></span>
                <span class="tag-6 isEn" v-show="isEn">
                  <!-- <span>y</span>
                  <span>p</span>
                  <span>a</span>
                  <span>r</span>
                  <span>e</span>
                  <span>h</span>
                  <span>T</span>
                  <span>e</span>
                  <span>n</span>
                  <span>e</span>
                  <span>G</span> -->
                  Gene Therapy
                </span>

                <div class="container-3" >
                  <div class="list">
                    <div class="row-item-0">
                      <span class="label-4">{{$t('dev-part2-c3-txt1')}}</span>
                    </div>
                    <div class="row-item-1">
                      <span class="name">{{$t('dev-part2-c2-txt1')}}</span>
                    </div>
                    <div class="row-item-2">
                      <span class="tag-6">{{$t('dev-part2-c1-txt1')}}</span>
                    </div>
                    <div class="row-item-3">
                      <span class="word-4">{{$t('dev-part2-c4-txt1')}}</span>
                    </div>
                  </div>
                  <div class="list-1">
                    <div class="row-item-0-1">
                      <div class="view">
                        <span class="word-5">KL001</span>
                        <img class="button-bg" src="@/assets/img/production/images/img_12.png" />
                      </div>
                    </div>
                    <div class="row-item-1-1">
                      <div class="label-wrapper-1">
                        <span class="label-5">KL002</span>
                      </div>
                    </div>
                    <div class="row-item-2-1">
                      <div class="label-wrapper-2">
                        <span class="label-6">KL003</span>
                      </div>
                    </div>
                    <div class="row-item-3-1">
                      <div class="klai-wrapper">
                        <span class="klai">KL-AI20</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="block-5">
                <div class="tag-wrapper">
                  <span class="tag-7">{{$t('weipilouxiangmu')}}</span>
                </div>
                <div class="container-4">
                  <div class="empty-4" />
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- 生产和质量这一整个板块删除 2024-05-22 -->
        <!-- <div class="group-26" id="shengchanzhiliang">
          <div class="group-27">
            <div class="caption-wrapper-2">
              <span class="caption-7">{{$t('dev-part3-txt-title')}}</span>
            </div>
            <div class="group-28">
              <img class="banner" src="@/assets/img/production/images/img_17.webp" />
              <div class="block-9">
                <span class="title-6">{{$t('dev-part3-txt1')}}</span>
                <span
                  class="article-4">{{$t('dev-part3-txt2')}}</span>
              </div>
            </div>
            <div class="group-29">
              <div class="block-10">
                <span class="title-7">{{$t('dev-part3-txt3')}}</span>
                <div class="container-11">
                  <span
                    class="article-5">{{$t('dev-part3-txt4')}}</span>

                </div>
              </div>
              <img class="cover" src="@/assets/img/production/images/img_18.webp" />
            </div>
            <div class="grid-2 zoomCenterTop">
              <div class="col-item-0-2" :class="{'en':isEn}">
                <div class="container-12 container-after">
                  <img class="icon-2" src="@/assets/img/production/images/img_19.png" />
                  <span class="info-2">{{$t('dev-part3-s1-t1')}}</span>
                 
                 
                  <div class="info-list-box" >
                    <span class="info-list">{{$t('dev-part3-s1-txt1')}}</span>
                   
                    <span class="info-list">{{$t('dev-part3-s1-txt2')}}</span>
                    <span class="info-list">{{$t('dev-part3-s1-txt3')}}</span>
                 </div>
                 
                </div>
                
              </div>
              <div class="col-item-0-2" :class="{'en':isEn}">
                <div class="container-12 container-after">
                  <img class="icon-2" src="@/assets/img/production/images/img_20.png" />
                  <span class="info-2">{{$t('dev-part3-s2-t1')}}</span>
                 
                  <div class="info-list-box" >
                    <span class="info-list">{{$t('dev-part3-s2-txt1')}}</span>
                   
                    <span class="info-list">{{$t('dev-part3-s2-txt2')}}</span>
                    <span class="info-list">{{$t('dev-part3-s2-txt3')}}</span>
                 </div>
                 
                </div>
                
              </div>

              <div class="col-item-0-2" :class="{'en':isEn}">
                <div class="container-12 container-after">
                  <img class="icon-2" src="@/assets/img/production/images/img_21.png" />
                  <span class="info-2">{{$t('dev-part3-s3-t1')}}</span>
                  <span class="info-2" v-if="isEn" style="color: #fff;margin-top: 0;">{{$t('dev-part3-s3-t1')}}</span>
                  <div class="info-list-box" >
                    <span class="info-list">{{$t('dev-part3-s3-txt1')}}</span>
                   
                    <span class="info-list">{{$t('dev-part3-s3-txt2')}}</span>
                    <span class="info-list">{{$t('dev-part3-s3-txt3')}}</span>
                 </div>
                 
                </div>
                
              </div>
              <div class="col-item-0-2" :class="{'en':isEn}">
                <div class="container-12 container-after">
                  <img class="icon-2" src="@/assets/img/production/images/img_22.png" />
                  <span class="info-2">{{$t('dev-part3-s4-t1')}}</span>
                 
                  <div class="info-list-box" >
                    <span class="info-list">{{$t('dev-part3-s4-txt1')}}</span>
                   
                    <span class="info-list">{{$t('dev-part3-s4-txt2')}}</span>
                    <span class="info-list">{{$t('dev-part3-s4-txt3')}}</span>
                 </div>
                 
                </div>
                
              </div>
              <div class="col-item-0-2" :class="{'en':isEn}">
                <div class="container-12 container-after">
                  <img class="icon-2" src="@/assets/img/production/images/img_23.png" />
                  <span class="info-2">{{$t('dev-part3-s5-t1')}}</span>
                 
                  <div class="info-list-box" >
                    <span class="info-list">{{$t('dev-part3-s5-txt1')}}</span>
                   
                    <span class="info-list">{{$t('dev-part3-s5-txt2')}}</span>
                 </div>
                 
                </div>
                
              </div>
            
            </div>
            <div class="group-30 zoomCenterTop">
              <div class="block-11" :class="{'en':isEn}">
                <div class="tag-wrapper-5">
                  <span class="tag-16">{{$t('dev-part3-card-txt1')}}</span>
                </div>
                <span
                  class="article-7"  :class="{'en':isEn}">{{$t('dev-part3-card-txt2')}}</span>
               
                <span class="detail-2"> <img class="icon-item-0" src="@/assets/img/prefecture/images/img_11.png" />{{$t('dev-part3-card-l-txt1')}}</span>
               
                <span class="detail-2"> <img class="icon-item-0" src="@/assets/img/prefecture/images/img_11.png" />{{$t('dev-part3-card-l-txt2')}}</span>
               
                <span class="detail-2"> <img class="icon-item-0" src="@/assets/img/prefecture/images/img_11.png" />{{$t('dev-part3-card-l-txt3')}}</span>
              </div>
              <div class="block-12">
                <div class="container-17">
                  <div class="label-wrapper-3">
                    <span class="label-11">{{$t('dev-part3-card2-txt1')}}</span>
                  </div>
                  <span class="article-8" :style="{marginTop:!isEn ? '60px':'20px'}">{{$t('dev-part3-card2-txt2')}}</span>
                </div>
                <div class="container-18">
                  <div class="word-wrapper">
                    <span class="word-11">{{$t('dev-part3-card2-txt3')}}</span>
                  </div>
                  <span
                    class="article-9" :style="{marginTop:!isEn ? '60px':'16px'}">{{$t('dev-part3-card2-txt4')}}</span>
                </div>
              </div>
            </div>
          </div>
        </div> -->
      </div>
    </div>
  </div>
</template>
<script>
import { menuFixed } from '@/utils/index'
import { WOW } from 'wowjs';

// import './index.css'
export default {
  components: {

  },
  data () {
    return {
      isEn: localStorage.getItem("lang") === 'EN',
      left: '',
      btnActiveIndex: 0,
      selectStatus: '',
      showIndex: 0,
      listData: [{
        img: require('@/assets/img/production/images/img_11.webp'),
        num1: 'dev-part2-c1-count1',
        unit1: 'dev-part2-c1-unit1',
        title1_1: 'dev-part2-c1-txt2',
        title1_2: 'dev-part2-c1-txt21',
        num2: 'dev-part2-c1-count2',
        unit2: 'dev-part2-c1-unit2',
        title2_1: 'dev-part2-c1-txt3',
        title2_2: 'dev-part2-c1-txt31',
        name: 'dev-part2-c1-txt4',
        content: 'dev-part2-c1-txt5'
      },
      {
        img: require('@/assets/img/production/images/img_112.webp'),
        num1: 'dev-part2-c2-count1',
        unit1: 'dev-part2-c2-unit1',
        title1_1: 'dev-part2-c2-txt2',
        num2: 'dev-part2-c2-count2',
        unit2: 'dev-part2-c2-unit1',
        class: 'two',
        title2_1: 'dev-part2-c2-txt3',
        name: 'dev-part2-c2-txt4',
        content: 'dev-part2-c2-txt5'
      }, {
        img: require('@/assets/img/production/images/img_113.webp'),
        num1: '≈28',
        unit1: 'dev-part2-c3-unit1',
        title1_1: 'dev-part2-c3-txt2',
        num2: '6.5-13',
        unit2: 'dev-part2-c3-unit2',
        class: 'three',
        title2_1: 'dev-part2-c3-txt3',
        name: 'dev-part2-c3-txt1',
        content: 'dev-part2-c3-txt5'
      },
      {
        img: require('@/assets/img/production/images/img_114.webp'),
        num1: 'dev-part2-c4-count1',
        class: 'three',
        unit1: 'dev-part2-c4-unit1',
        title1_1: 'dev-part2-c4-txt2-1',
        title1_2: 'dev-part2-c4-txt2',
        num2: 'dev-part2-c4-count2',
        unit2: 'dev-part2-c4-unit2',
        title2_1: 'dev-part2-c4-txt2-1',
        title2_2: 'dev-part2-c4-txt3 ',
        name: 'dev-part2-c4-txt1',
        content: 'dev-part2-c4-txt5'
      }]
    }
  },
  created () {

  },
  methods: {
    bannerloadEvent () {
      this.left = $('.header-nav').offset() && $('.header-nav').offset().left + 74 - $('.top-banner').offset().left
    },
    onmouseoverEvent (type) {
      this.selectStatus = type
    },
    tabEvent (index, id,num=0) {
      this.btnActiveIndex = index
      let isfixed = $('.linkBox').css('position') === 'fixed'
      let offset = index == 0 && isfixed ? 65 : 0  
      if(!isfixed && index!==0){
        offset -= 65
      }
      const top = $('#' + id).offset().top - 134 + offset - num
      console.log(top)
      $("html,body").animate({ scrollTop: top }, 500);
    },
    switchEvent (index) {
      this.showIndex = index
      $('.grid >div').removeClass('active')
      $('.grid >div')[index].setAttribute('class', 'col-item-1 active')
    },
    onScrollSwitchTab(){
      var that = this
      // window.addEventListener('scroll', function () {
      //   var tarElArr = [$("#jishupingtai"), $("#yanfaguanxian"), $("#shengchanzhiliang")]
      //   var tarElScrollArr = [tarElArr[0].offset().top - 110, tarElArr[1].offset().top - 110, tarElArr[2].offset().top - 110] //[280, 1196, 1886, 2650]
      //   var scrollTop = document.documentElement.scrollTop || document.body.scrollTop;

      //   console.log(scrollTop)
      //   if (scrollTop >= 0 && scrollTop <= tarElScrollArr[0]) {
      //     that.btnActiveIndex = 0

      //   }
      //   else if (tarElScrollArr[0] < scrollTop && scrollTop <= tarElScrollArr[1]) {
      //     that.btnActiveIndex = 0
      //   }
      //    else if (tarElScrollArr[1] < scrollTop && scrollTop <= tarElScrollArr[2]) {
      //     that.btnActiveIndex = 1
      //   } else  {
      //     that.btnActiveIndex = 2
      //   } 

      // })
      window.addEventListener('scroll', function () {
        var tarElArr = [$("#jishupingtai"), $("#yanfaguanxian")]
        var tarElScrollArr = [tarElArr[0].offset().top - 110, tarElArr[1].offset().top - 110] //[280, 1196, 1886, 2650]
        var scrollTop = document.documentElement.scrollTop || document.body.scrollTop;

        console.log(scrollTop)
        if (scrollTop >= 0 && scrollTop <= tarElScrollArr[0]) {
          that.btnActiveIndex = 0

        }
        else if (tarElScrollArr[0] < scrollTop && scrollTop <= tarElScrollArr[1]) {
          that.btnActiveIndex = 0
        }
         else   {
          that.btnActiveIndex = 1
        } 

      })
    },
  },
  mounted () {
    menuFixed()
    setTimeout(() => {
      this.left = $('.header-nav').offset() && $('.header-nav').offset().left + 74 - $('.top-banner').offset().left
    }, 100)
    let index = this.$route.query.index;

    this.$nextTick(() => {
      new WOW().init();
      this.bannerloadEvent()
     index && $('.link-btn')[index].click()
    })
    this.onScrollSwitchTab()
  }

}
</script>

<style lang="less" scoped>
.isEn{
  .container-13{
    padding: 40px 12px 78px;
  }
  .container-12{
    padding: 39px 12px 76px;
  }
  .article-7{
    margin: 20px 0 0 18px;
    height:auto;
    position: relative;
  }
  .desc-2,.desc-3{
    white-space:inherit;
  }
  .icon-item-0{
    bottom: 200px
  }
  .icon-item-1{
    bottom: 140px
  }
  .block-11{
    padding: 40px 12px;
  }
  .article-8{
    overflow: inherit;
  }
  .article-9{
    // margin: 30px 0 0 19px;
  }
}

.top-banner{
      width: 100%;
      background: url(../../assets/img/webp/production.webp) no-repeat top !important;
      background-size: cover;
  }
.group-6 {
  .flex {
    flex: 1;
  }

  .flex3 {
    flex: 3;
  }
}

.item3 {
  width: 300px;
  margin: 3px 0 0 79px;

  .wrapper {
    width: 150px
  }

  .group-15 {
    width: 110px
  }

  .group-16 {
    width: 150px
  }
}
.item2{
  .group-16{
    width:120px;
  }
}
.item0{
  .group-15{
    width:54px;
  }
}
.ml-6px {
  margin-left: 6px !important;
}
// @import url('./index.less');





.col-item-0-2 {
  width: 242px;
  height: 342px;
  padding-top: 2px;
  display: flex;
  justify-content: center;
  align-self: center;
  position: relative;
  overflow: hidden;
  border-radius: 8px;
  /* background: #fff; */
  &.en{
    .info-2{
      margin: 10px 0 0 19px;
      font-size: 15px;
    line-height: 1.5;
    }
    .info-list-box{
      height: 187px;
      .info-list{
        line-height: 1.4;
        margin: 16px 0 0 26px;
        &::after{
          top: 6px;
        }
      }
    }
  }
}


.wrapper {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-self: center;
  height: 85px;
  width: 98px;
  &.en{
    width: 131px;
    .group-15{
      width: 140px;
    }
    .group-16{
      width: 100%;
    }
  }
}
.container-2 {
  display: flex;
  margin-left: 79px;
  justify-content: flex-start;
  align-self: flex-start;
  position: relative;
  padding-right: 30px;
  /* height: 120px; */
  /* overflow-y: scroll; */
  &.en{
    /* height: 300px; */
  overflow-y: scroll;
  .article-1{
    font-size: 14px;
    /* width: 790px; */
  }
  .caption-5{
    font-size: 19px;
  }
  }
}
.block-11 {
  background-color: #222d44;
  display: flex;
  flex-direction: column;
  margin-left: 41px;
  justify-content: flex-start;
  align-self: center;
  position: relative;
  width: 480px;
  padding: 60px 12px;
  border-radius: 20px;
  height: 490px;
  /* overflow-y: scroll; */
  &.en{
    .article-7 {
      line-height: 1.8;
    }
    .detail-2 {
      color: rgba(255, 255, 255, 1);
      font-size: 14px;
      line-height: 1.5;
      margin: 14px 0 0 10px;
      position: relative;
      padding-left: 39px;
    }
    .icon-item-0{
      top: 1px;
    }
  }
}
.article-7 {
  color: rgba(255, 255, 255, 1);
  font-size: 14px;
  margin: 20px 0 0 18px;
  line-height: 30px;
  align-self: flex-start;
  width: 406px;

  white-space: break-spaces;

  &.en{
    line-height: 1.4;

  }
}






</style>
<style src="./index.css" scoped />
;





// WEBPACK FOOTER //
// src/view/Production/index.vue